import { render } from "./UEInternationalListView.vue?vue&type=template&id=768b6cdb&scoped=true"
import script from "./UEInternationalListView.vue?vue&type=script&lang=js"
export * from "./UEInternationalListView.vue?vue&type=script&lang=js"

import "./UEInternationalListView.vue?vue&type=style&index=0&id=768b6cdb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768b6cdb"]])

export default __exports__